import { render, staticRenderFns } from "./TableNav.vue?vue&type=template&id=0fec864d&scoped=true&"
import script from "./TableNav.vue?vue&type=script&lang=js&"
export * from "./TableNav.vue?vue&type=script&lang=js&"
import style0 from "./TableNav.vue?vue&type=style&index=0&id=0fec864d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fec864d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fec864d')) {
      api.createRecord('0fec864d', component.options)
    } else {
      api.reload('0fec864d', component.options)
    }
    module.hot.accept("./TableNav.vue?vue&type=template&id=0fec864d&scoped=true&", function () {
      api.rerender('0fec864d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/TableNav.vue"
export default component.exports